import { lazy, Suspense } from "react";
import { PageSkeleton } from "../../customs/skeleton/main";

const Main = lazy(() => import("../../components/transactions/debitNote/debitNote"));

const DebitNote = () => {
  return (
        <Suspense fallback={<PageSkeleton />}>
          <Main />
        </Suspense>
  );
};

export default DebitNote;

